<template>
  <div class="card p-4 shadow-sm">
    <div class="text-center mb-4">
      <h4 class="m-0">Reporte de Propinas - Restaurante</h4>
    </div>

    <!-- Filtros de fecha y hora -->
    <div class="row g-3 mb-4 justify-content-center">
      <div class="col-md-2">
        <label class="form-label">Fecha Inicio</label>
        <input type="date" v-model="fechaInicio" class="form-control" />
      </div>
      <div class="col-md-2">
        <label class="form-label">Hora inicio</label>
        <input type="time" v-model="horaInicio" class="form-control" />
      </div>
      <div class="col-md-2">
        <label class="form-label">Fecha Fin</label>
        <input type="date" v-model="fechaFin" class="form-control" />
      </div>
      <div class="col-md-2">
        <label class="form-label">Hora fin</label>
        <input type="time" v-model="horaFin" class="form-control" />
      </div>
      <div class="col-md-2 d-flex align-items-end">
        <button
          class="btn btn-primary w-100"
          @click="obtenerReporte"
          :disabled="cargando || !fechaInicio || !fechaFin"
        >
          <span v-if="cargando" class="spinner-border spinner-border-sm me-1"></span>
          Generar
        </button>
      </div>
      <div class="col-md-2 d-flex align-items-end">
        <button
          class="btn btn-danger w-100"
          @click="descargarPDF"
          :disabled="!reporte || cargando"
          title="Descargar PDF"
        >
          <i class="bi bi-file-pdf me-1"></i> PDF
        </button>
      </div>
      <div class="col-md-2 d-flex align-items-end">
        <button
          class="btn btn-success w-100"
          @click="descargarExcel"
          :disabled="!reporte || cargando"
          title="Descargar Excel"
        >
          <i class="bi bi-file-earmark-excel me-1"></i> Excel
        </button>
      </div>
    </div>

    <!-- Resultados -->
    <div v-if="reporte" class="mt-3">
      <div class="text-muted small text-center mb-2">
        {{ formatearFecha(reporte.fecha_inicio) }} – {{ formatearFecha(reporte.fecha_fin) }}
        &nbsp;|&nbsp; {{ horaInicio }} – {{ horaFin }}
      </div>
      <div class="table-responsive">
        <table class="table table-bordered text-center mb-0">
          <thead class="table-light">
            <tr>
              <th>Periodo</th>
              <th>Propina (con impuestos)</th>
              <th>IVA y otros impuestos</th>
              <th>Propina Neta</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ formatearFecha(reporte.fecha_inicio) }} - {{ formatearFecha(reporte.fecha_fin) }}</td>
              <td>Q{{ Number(reporte.propina_con_iva).toFixed(2) }}</td>
              <td class="text-danger">Q{{ Number(reporte.impuestos).toFixed(2) }}</td>
              <td class="fw-bold text-success">Q{{ Number(reporte.propina_sin_iva).toFixed(2) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mt-4">
        <h5 class="text-center mb-3">Propinas por Mesero</h5>
        <div v-if="reporte.propinas_por_mesero && reporte.propinas_por_mesero.length" class="table-responsive">
          <table class="table table-striped text-center mb-0">
            <thead class="table-light">
              <tr>
                <th>Mesero</th>
                <th>Cuentas</th>
                <th>Propina (con impuestos)</th>
                <th>IVA y otros impuestos</th>
                <th>Propina Neta</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="mesero in reporte.propinas_por_mesero" :key="mesero.id_empleado">
                <td>{{ mesero.nombre_empleado }}</td>
                <td>{{ mesero.cantidad_cuentas }}</td>
                <td>Q{{ Number(mesero.propina_con_iva).toFixed(2) }}</td>
                <td class="text-danger">Q{{ Number(mesero.impuestos).toFixed(2) }}</td>
                <td class="fw-bold text-success">Q{{ Number(mesero.propina_sin_iva).toFixed(2) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p v-else class="text-center text-muted mb-0">No hay propinas registradas por mesero en este periodo.</p>
      </div>
    </div>

    <!-- Estado inicial / vacío -->
    <div v-else-if="!cargando" class="text-center text-muted py-4">
      <p class="mb-0">Seleccione un rango de fechas para generar el reporte.</p>
    </div>

    <!-- Toast -->
    <div v-if="mostrarToast" class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1055;">
      <div class="toast show text-white" :class="tipoToast === 'success' ? 'bg-success' : 'bg-danger'">
        <div class="d-flex">
          <div class="toast-body">{{ mensajeToast }}</div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="mostrarToast = false"></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { API_URL } from '@/config/config.js';

export default {
  name: 'PropinasRestaurante',
  data() {
    return {
      fechaInicio: '',
      fechaFin: '',
      horaInicio: '06:30',
      horaFin: '23:00',
      reporte: null,
      cargando: false,
      mostrarToast: false,
      mensajeToast: '',
      tipoToast: 'success',
    };
  },
  methods: {
    async obtenerReporte() {
      if (this.fechaInicio > this.fechaFin) {
        this.mostrarMensaje('La fecha inicio debe ser menor a fecha fin', 'danger');
        return;
      }

      try {
        this.cargando = true;
        const { data } = await axios.get(`${API_URL}/total-propinas`, {
          params: { fecha_inicio: this.fechaInicio, fecha_fin: this.fechaFin, hora_inicio: this.horaInicio, hora_fin: this.horaFin }
        });
        this.reporte = data;
      } catch (error) {
        console.error(error);
        this.reporte = null;
        this.mostrarMensaje('Error al generar el reporte', 'danger');
      } finally {
        this.cargando = false;
      }
    },
    formatearFecha(fecha) {
      if (!fecha) return '';
      const [year, month, day] = fecha.split('-');
      return `${day}/${month}/${year}`;
    },
    mostrarMensaje(mensaje, tipo) {
      this.mensajeToast = mensaje;
      this.tipoToast = tipo;
      this.mostrarToast = true;
      setTimeout(() => this.mostrarToast = false, 3000);
    },
    async descargarPDF() {
      if (!this.reporte) {
        this.mostrarMensaje('No hay datos para generar el PDF', 'danger');
        return;
      }

      try {
        const response = await axios.get(`${API_URL}/total-propinas-pdf`, {
          params: { fecha_inicio: this.fechaInicio, fecha_fin: this.fechaFin, hora_inicio: this.horaInicio, hora_fin: this.horaFin },
          responseType: 'blob'
        });

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `Reporte_Propinas_${this.fechaInicio}_${this.fechaFin}.pdf`;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } catch (error) {
        console.error('Error descargando PDF:', error);
        this.mostrarMensaje('Error al generar el PDF', 'danger');
      }
    },
    async descargarExcel() {
      if (!this.reporte) {
        this.mostrarMensaje('No hay datos para generar el Excel', 'danger');
        return;
      }

      try {
        const response = await axios.get(`${API_URL}/total-propinas-excel`, {
          params: { fecha_inicio: this.fechaInicio, fecha_fin: this.fechaFin, hora_inicio: this.horaInicio, hora_fin: this.horaFin },
          responseType: 'blob'
        });

        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `Reporte_Propinas_${this.fechaInicio}_${this.fechaFin}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } catch (error) {
        console.error('Error descargando Excel:', error);
        this.mostrarMensaje('Error al generar el Excel', 'danger');
      }
    }
  }
};
</script>

<style scoped>
.table th, .table td {
  vertical-align: middle;
}
</style>
